import { Card, CardContent, Skeleton, CardActions, Button } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import { useBusinessLocationsDetailedColumns } from '../helper/businessLocationsDetailedColumns'
import {
    availablePageSizes,
    defaultPageSize,
} from '@/schemas/searchParams/searchParamsPaginationSchema'
import { BusinessDetailsTableLayout } from './BusinessDetailsTableLayout'

export const BusinessDetailsPendingComponent: React.FC = () => {
    const { t } = useTranslation()
    const columns = useBusinessLocationsDetailedColumns()

    return (
        <Card>
            <CardContent>
                <h3>{t('business.business')}</h3>
                <BusinessDetailsTableLayout
                    businessName={<Skeleton />}
                    description={<Skeleton />}
                />
                <h3>{t('business.location')}</h3>
                <DataGrid
                    sx={{ mt: 2 }}
                    rows={[]}
                    columns={columns}
                    initialState={{
                        pagination: {
                            paginationModel: { pageSize: defaultPageSize },
                        },
                    }}
                    pageSizeOptions={availablePageSizes}
                    disableRowSelectionOnClick={true}
                    loading={true}
                />
            </CardContent>

            <CardActions style={{ justifyContent: 'flex-end' }}>
                <Button disabled={true}>{t('common.back')}</Button>
                <Button disabled={true} variant={'outlined'}>
                    {t('common.edit')}
                </Button>
            </CardActions>
        </Card>
    )
}
